import type { IconNode } from '../types';

/**
 * @name snowman
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjYiIHI9IjQiIC8+CiAgPHBhdGggZD0iTTEyIDE0aC4wMSIgLz4KICA8cGF0aCBkPSJNMTIgMThoLjAxIiAvPgogIDxwYXRoIGQ9Ik0yIDloMlY3IiAvPgogIDxwYXRoIGQ9Ik03IDEyIDQgOSIgLz4KICA8cGF0aCBkPSJNMTcuOCAxMS4xIDIwIDkiIC8+CiAgPHBhdGggZD0iTTIwIDd2MmgyIiAvPgogIDxwYXRoIGQ9Ik05IDguN2E3IDcgMCAxIDAgNiAwIiAvPgogIDxwYXRoIGQ9Ik01IDIyaDE0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/snowman
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const snowman: IconNode = [
  ['circle', { cx: '12', cy: '6', r: '4', key: '1frrej' }],
  ['path', { d: 'M12 14h.01', key: '1etili' }],
  ['path', { d: 'M12 18h.01', key: 'mhygvu' }],
  ['path', { d: 'M2 9h2V7', key: '1vkozr' }],
  ['path', { d: 'M7 12 4 9', key: 'k1na9a' }],
  ['path', { d: 'M17.8 11.1 20 9', key: '18o8y9' }],
  ['path', { d: 'M20 7v2h2', key: 'j0rksc' }],
  ['path', { d: 'M9 8.7a7 7 0 1 0 6 0', key: 'x9vvq1' }],
  ['path', { d: 'M5 22h14', key: 'ehvnwv' }],
];

export default snowman;
